var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7425 0.7426C12.425 1.4251 12.425 2.5276 11.7425 3.2101L4.95252 10.0001L11.7425 16.7901C12.425 17.4726 12.425 18.5751 11.7425 19.2576C11.06 19.9401 9.95752 19.9401 9.27502 19.2576L1.24252 11.2251C0.560021 10.5426 0.560021 9.4401 1.24252 8.7576L9.27502 0.7251C9.94002 0.0600994 11.06 0.0600998 11.7425 0.7426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBackArrow);
export default __webpack_public_path__ + "static/media/dashboard-back-arrow.6d7a01dfef05b94a4916924ba71d992f.svg";
export { ForwardRef as ReactComponent };